import React, { useState } from "react";
import "../../styles/industries.css"; // Updated CSS file
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTractor,
  faGasPump,
  faCalendarAlt,
  faHardHat,
  faShieldAlt,
  faGraduationCap,
  faHeartbeat,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";

const Industries = () => {
  const [activeTab, setActiveTab] = useState("all");

  const industries = [
    {
      icon: faTractor,
      title: "Agriculture",
      description:
        "Cutting-edge solutions for agricultural businesses with AI-driven CRM enhancements and digital accessibility.",
      realProject:
        "Developed custom Salesforce CRM enhancements for agricultural firms, integrating competitor SEO analysis dashboards and ADA compliance remediation to cultivate a digital edge in the field.",
      technologies: [
        "Salesforce Lightning",
        "AI-Driven Insights",
        "SEO Analytics",
        "ADA WCAG 2.1",
        "React Frontend",
        "Node.js Backend",
      ],
      metrics: { clients: "12+", growth: "280%", compliance: "100%" },
      category: "enterprise",
    },
    {
      icon: faGasPump,
      title: "Fuel & Energy",
      description:
        "Dynamic visual branding solutions for the energy sector with high-impact graphic designs.",
      realProject:
        "Designed over 400 fuel graphics for Marathon Petroleum Corp, creating a visually cohesive brand identity with automated design templates and interactive marketing tools.",
      technologies: [
        "Adobe Illustrator",
        "SVG Optimization",
        "Brand Automation",
        "Digital Signage",
        "Marketing APIs",
      ],
      metrics: { graphics: "400+", campaigns: "15+", impact: "350%" },
      category: "creative",
    },
    {
      icon: faCalendarAlt,
      title: "Event & Entertainment",
      description:
        "Next-gen analytics platforms to amplify online presence and audience engagement for entertainment brands.",
      realProject:
        "Delivered comprehensive social media and website analytics solutions with real-time engagement tracking and predictive audience behavior models to spotlight performance metrics.",
      technologies: [
        "Google Analytics 4",
        "Social API Integration",
        "React Dashboards",
        "Predictive AI",
        "Data Visualization",
      ],
      metrics: { engagement: "300%", platforms: "10+", insights: "Real-Time" },
      category: "analytics",
    },
    {
      icon: faHardHat,
      title: "Construction",
      description:
        "Robust software suites for project management and client relations in the construction industry.",
      realProject:
        "Created tailored CRMs and project management software with automated workflows, resource tracking, and mobile integration to build efficiency into every project phase.",
      technologies: [
        "Custom CRM Dev",
        "Project Tracking",
        "Workflow Automation",
        "Mobile Apps",
        "Cloud Sync",
      ],
      metrics: { projects: "40+", efficiency: "200%", delays: "-60%" },
      category: "enterprise",
    },
    {
      icon: faShieldAlt,
      title: "Private Security",
      description:
        "Strategic digital visibility solutions to safeguard and expand client outreach for security firms.",
      realProject:
        "Enhanced website SEO and optimized Google Business Pages with geo-targeted strategies and secure lead capture systems to protect and grow security service outreach.",
      technologies: [
        "SEO Optimization",
        "Google My Business",
        "Geo-Targeting",
        "Lead Funnels",
        "Secure Analytics",
      ],
      metrics: { visibility: "400%", leads: "250+", ranking: "Top 5" },
      category: "marketing",
    },
    {
      icon: faGraduationCap,
      title: "Education",
      description:
        "Secure and scalable intranet solutions to empower educational institutions with seamless communication.",
      realProject:
        "Contributed to intranet development with encrypted data portals, collaborative tools, and user-friendly interfaces to educate and connect academic communities.",
      technologies: [
        "Intranet Architecture",
        "Data Encryption",
        "Collaboration Suite",
        "User UX Design",
        "Scalable Cloud",
      ],
      metrics: { users: "1500+", security: "Top-Tier", adoption: "95%" },
      category: "services",
    },
    {
      icon: faHeartbeat,
      title: "Healthcare",
      description:
        "Compliant and secure solutions ensuring regulatory adherence and patient data protection.",
      realProject:
        "Performed ADA compliance updates and HIPAA audits with automated monitoring systems and accessibility frameworks to heal digital gaps in healthcare services.",
      technologies: [
        "HIPAA Standards",
        "ADA Compliance",
        "Audit Automation",
        "Secure Portals",
        "Accessibility Tools",
      ],
      metrics: { audits: "30+", compliance: "100%", accessibility: "WCAG 2.1" },
      category: "compliance",
    },
    {
      icon: faChartLine,
      title: "Investing & Startups",
      description:
        "Innovative platforms for investment decision-making and startup-investor connectivity.",
      realProject:
        "Built a crowd-controlled pitch voting app with blockchain-secured voting, AI-driven investor matching, and real-time analytics to fund the future of innovation.",
      technologies: [
        "Blockchain Voting",
        "AI Matching",
        "Real-Time Analytics",
        "React Native",
        "Secure API",
      ],
      metrics: { startups: "180+", funding: "$1.5M+", matches: "60+" },
      category: "innovation",
    },
  ];

  const filteredIndustries =
    activeTab === "all"
      ? industries
      : industries.filter((industry) => industry.category === activeTab);

  return (
    <main className="industries-container">
      <section className="industries-header">
        <h1 className="industries-title">Industries Served</h1>
        <p className="industries-lead">
          Transforming industries with tailored innovation.
        </p>
      </section>

      <section className="industries-grid">
        {filteredIndustries.map((industry, index) => (
          <div key={index} className="industry-card">
            <FontAwesomeIcon icon={industry.icon} size="2x" />
            <h3 className="card-title">{industry.title}</h3>
            <p className="card-description">{industry.description}</p>
            <div className="real-project">
              <h4>🚀 Real Project Impact</h4>
              <p>{industry.realProject}</p>
            </div>
            <div className="tech-stack">
              <h4>Technologies Used</h4>
              <ul>
                {industry.technologies.map((tech, i) => (
                  <li key={i}>{tech}</li>
                ))}
              </ul>
            </div>
            <div className="metrics">
              {Object.entries(industry.metrics).map(([key, value], i) => (
                <div key={i}>
                  <strong>{key}:</strong> {value}
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
    </main>
  );
};

export default Industries;